import eventBus from './event-bus'
import * as server from './server'
import router from '../router'
import { Dialog } from 'vant'

export function getQueryParam (paramName) {
  const url = window.location.search.substring(1)
  const regex = new RegExp(`(^|&)${paramName}=([^&]*)(&|$)`, 'i')
  const match = url.match(regex)
  return match ? decodeURIComponent(match[2]) : null
}

export function errorHint (error,showMessage = true) {
  if (error.code === 401) {
    // 需要权限，提示跳转登录
    Dialog.confirm({
      title: '提示',
      message: '登录状态已失效，请重新登录！'
    })
      .then(() => {
        // on confirm
        localStorage.removeItem('token')
        // router.push({ path: '/login' })
        eventBus.$emit('openLogin')
      })
      .catch(() => {
        // on cancel
      })

    return
  }

  // 禁止解析
  if (error.code === 100500) {
    router.push({ path: '/stopParsing?type=10&btnType=1' })
    return
  }

  // 密码错误
  if (error.code === 100701) {
    const id = getQueryParam('id')
    router.push({ path: '/checkPerm?type=1&codeId=' + error.data + '&forward=' + encodeURIComponent(window.location.pathname + '?id=' + id) })
    return
  }

  console.log('error', error)
  let message
  if (error.message || error.msg) {
    message = error.message || error.msg
  } else {
    message = error.statusText
  }
  if(showMessage){
    eventBus.$emit('showMessage', {
      showClose: true,
      type: 'error',
      message
    })
  }
}

export function wrapResult (promise) {
  return promise.catch(e => {
    errorHint(e)
    throw e
  })
}

export function wrapJsonResult (promise,showMessage = true) {
  return wrapResult(promise).then(data => {
    if (data.code == null) {
      return Promise.resolve(data)
    } else if (data.code === 200 || data.code === 0) {
      if (data.data === undefined) {
        return Promise.resolve(data)
      } else {
        return Promise.resolve(data.data)
      }
    } else {
      console.log('error is', data)
      errorHint(data,showMessage)
      return Promise.reject(data)
    }
  })
}

export function wrapJsonResultV1 (promise) {
  return wrapResult(promise).then(data => {
    if (data.code == null) {
      return Promise.resolve(data)
    } else if (data.code === 200 || data.code === 0) {
      return Promise.resolve(data)
    } else {
      console.log('error is', data)
      errorHint(data)
      return Promise.reject(data)
    }
  })
}

export function wrapJsonResultV2 (promise) {
  return wrapResult(promise).then(data => {
    if (data.code == null) {
      return Promise.resolve(data)
    } else if (data.code === 200 || data.code === 0) {
      return Promise.resolve(data.rows)
    } else {
      console.log('error is', data)
      errorHint(data)
      return Promise.reject(data)
    }
  })
}
function prepareQuery (url, query) {
  let param = ''
  for (const key of Object.keys(query)) {
    if (query[key]) {
      param += '&' + key + '=' + encodeURIComponent(query[key])
    }
  }
  if (param) {
    if (url.indexOf('?') === -1) {
      url += '?' + param.substring(1)
    } else {
      url += param
    }
  }
  return url
}
export function httpGet (url, arg = {}) {
  return server.getJson(url, arg)
}

export function getJsonResult (url, arg = {},showMessage = true) {
  url = prepareQuery(url, arg)
  return wrapJsonResult(server.getJson(url, arg),showMessage)
}

export function postJsonReturn (url, arg = {}) {
  return wrapJsonResult(server.postJson(url, arg).then(r => r.json()))
}

export function postJsonReturnV1 (url, arg = {}) {
  return wrapJsonResultV1(server.postJson(url, arg).then(r => r.json()))
}

export function getJsonReturnV1 (url, arg = {}) {
  url = prepareQuery(url, arg)
  return wrapJsonResultV1(server.getJson(url, arg))
}

export function getJsonResultV2 (url, arg = {}) {
  return wrapJsonResultV2(server.getJson(url, arg))
}

export function getJsonResultPut (url, arg = {}) {
  return wrapJsonResultV1(server.putJson(url, arg).then(r => r.json()))
}

export function getJsonResultDelete (url, arg = {}) {
  return wrapJsonResultV1(server.deleteData(url, arg).then(r => r.json()))
}



// WEBPACK FOOTER //
// ./src/utils/server-wrapper.js